import { ChangeDetectorRef, Component, OnChanges, SimpleChanges, inject, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TableSort } from '../../types/sort.type';
import { SortDirection } from '../../types/sort-direction.type';

import { SortIconComponent } from '../sort-icon/sort-icon.component';

enum AriaSort {
  NONE = 'NONE',
  ASC = 'ASC',
  DESC = 'DESC'
}

import { TranslatePipe } from '../../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-table-header',
  templateUrl: 'table-header.component.html',
  styleUrls: ['table-header.component.scss'],
  imports: [NgTemplateOutlet, SortIconComponent,
    TranslatePipe],
  host: {
    '[class.td-wb-table-header--hover]': 'hover',
    '(mouseenter)': 'onMouseEnter()',
    '(mouseleave)': 'onMouseLeave()'
  }
})
export class TableHeaderComponent implements OnChanges {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  readonly sort = input<() => void>(undefined);
  readonly sortDirections = input<Array<TableSort>>(undefined);
  readonly column = input<string>(undefined);

  hover: boolean = false;

  ariaSort: string = AriaSort.NONE;

  onMouseEnter(): void {
    this.hover = true;
    this.changeDetectorRef.detectChanges();
  }

  onMouseLeave(): void {
    this.hover = false;
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sortDirections !== undefined) {
      this.setAriaSort();
    }
  }

  isSortable(): boolean {
    return this.sort() !== undefined;
  }

  onClick(event: Event): void {
    event.preventDefault();
    this.sort()();
  }

  private setAriaSort(): void {
    const sortDirections = this.sortDirections();
    if (sortDirections === undefined) {
      this.ariaSort = AriaSort.NONE;
    } else if (sortDirections[0]?.prop !== this.column()) {
      this.ariaSort = AriaSort.NONE;
    } else {
      this.ariaSort = sortDirections[0]?.dir === SortDirection.ASC ? AriaSort.ASC : AriaSort.DESC;
    }
  }
}
